import DefinitionPropertiesEdit from './DefinitionPropertiesEdit';
import PaletteAdapter from './PaletteAdapter';

export default {
  __init__: [
    'definitionPropertiesEdit',
    'definitionPropertiesPaletteAdapter'
  ],
  definitionPropertiesEdit: [ 'type', DefinitionPropertiesEdit ],
  definitionPropertiesPaletteAdapter: [ 'type', PaletteAdapter ]
};
